import Link from "next/link";
import React from "react";
import styled from "styled-components";

export default function TermsComponent(): React.ReactElement {
  const PageBox = styled.div`
    background-color: #0e1017;
    padding-top: 30px;
    background-image: url("/images/PrivacyPolicy/web-bg.svg");
    background-position: top;
    background-repeat: no-repeat;
    padding-bottom: 80px;

    // @media (max-width: 1280px) {
    //   font-size: 20px;
    //   margin: 0px 5px;
    // }
  `;

  const Container = styled.div`
    width: 80%;
    margin: auto;
    margin-top: 100px;
    // @media (max-width: 1280px) {
    //   font-size: 20px;
    //   margin: 0px 5px;
    // }
  `;

  const TermsContainer = styled.div`
    background-color: #14161f;
    margin: auto;
    border-radius: 13px;
    padding: 40px;
    color: rgb(84, 92, 110);

    & h1 {
      color: white;
      margin: 40px 0px;
      font-size: 20px;
    }
    // @media (max-width: 1280px) {
    //   font-size: 20px;
    //   margin: 0px 5px;
    // }
  `;

  const Header = styled.h4`
    display: flex;
    width: 100%;
    font-family: "N B";
    font-size: 30px;
    color: rgb(255, 255, 255);
    margin-bottom: 1rem;
    position: relative;
  `;

  const DateText = styled.h4`
    color: rgb(84, 92, 110);
    font-size: 12px;
    // @media (max-width: 1280px) {
    //   font-size: 20px;
    //   margin: 0px 5px;
    // }
  `;

  return (
    <PageBox>
      <Container>
        <Header>Terms and Conditions of WRewards</Header>
        <DateText>Date of last modification: 01.11.2023. at 08:00 CET (UTC+1)</DateText>
        <TermsContainer>
          <div>
            <h1>1. Introduction</h1>
            <p>
              Welcome to WRewards.com! Before you get started, we ask that you please read the Terms
              and Conditions (T&C) prior to using our website. We kindly ask you to read them
              carefully, so that confusion can be avoided, and so your user experience is the best
              it can be! If you do not agree to accept and follow all of the Conditions, please
              refrain from opening an account and/or using the Website. Further use of the Website
              will indicate your acceptance of the Conditions. Conditions were enacted on
              01.11.2022. We want you to enjoy the time you spend here, and because this is a
              website where we discuss, show videos of and offer casino related deals that involve
              Gambling, there are a number of laws and regulations that regulate our activities.
              These Terms are explained as clearly as possible in these terms and conditions
              (&quot;the Terms&quot;). The WRewards.com Terms are how we let you know what you can
              and can’t do on WRewards.com, how we will use your personal information, and how we
              manage the Website. If you still have any questions after reading the T&C, please get
              in touch with the Support team via the following format: by filling out the “Contact”
              form that is found under the “About” tab at the bottom of the WRewards website.
            </p>
          </div>
          <div>
            <h1>2. The Basics</h1>
            <p>
              The Terms are a binding agreement between WRewards.com and you as the user, and by
              using the Website, you agree that you have read and accepted the Terms and any
              amendments thereto. If you do not agree with the Terms, you should not register or
              continue to use the Website. We may change these Terms at any time. Where we do so in
              a material way, we will contact you and inform you in advance of the new Terms.
            </p>
          </div>
          <div>
            <h1>3. Definitions</h1>
            <p>
              You will see the following terms used throughout the Terms: &quot;Offer&quot; shall
              cover all promotional offers that gift a tangible reward, whether pecuniary or
              non-pecuniary in nature, including but not limited to: Giveaway prizes, Shop prizes,
              welcome offers, Casino sponsored offers that are limited to WRewards.com users,
              free/bonus spins, sponsored pecuniary rewards, etc. For more information on the Offers
              we promote on our website, please contact Support. &quot;Terms&quot; are these terms,
              conditions and rules which you agree to when using the Site. &quot;Site&quot;
              www.WRewards.com, and including, if applicable, any mobile and mobile application
              version thereof or any other subdomains of &quot;WRewards.com&quot;. Words like “We”,
              “Us”, “Our”, “Ours” refer to WRewards, the Team, and the www.WRewards.com website.
              “User” refers to any physical or legal entity registered on our website, as well as
              guests entering the website, without prior registration. Where convenient words “You”
              and “Yours” refer to our Users and/or our Guests. &quot;Your Account&quot; is your
              user account on the Site. “Privacy Policy” refers to the way we handle your personal
              data on our website, pursuant to and in accordance with the required,
              industry-relevant data-protection laws and regulations. Under Data Protection Law we
              refer to the regulation governing this subject as stipulated by GDPR (General Data
              Protection Regulation No. 679/2016/EC). Furthermore, under Data Protection Law we also
              refer to the Terms set in Directive 58/2002/EC, amended in 2006, further amended in
              2009, stipulating Cookies website policy. “Cookie” is a short-text file placed on the
              User’s device by our website or third-party websites (partner websites). They are used
              for the purpose of offering the best possible user experience. “User device” – a
              laptop, desktop, tablet or smartphone, or any device used to access the website.
            </p>
          </div>
          <div>
            <h1>4. Social Gaming & Information</h1>
            <p>
              The Website serves as a “social gaming” venue and does not provide paid online
              gambling services. We are NOT a casino. No real money is being handled on our website
              and you will never be asked to spend funds on our website. For users looking for real
              gambling offers, we provide information on the websites offering online gambling
              services, for informational and promotional purposes only. We also provide
              entertainment via video-streamed content, and reviews of games and articles for
              informational purposes only. The purpose of this website is to offer followers of
              WRewards an entertaining and informative experience.
            </p>
            <p>
              4.1 The G-POINTS used on the site cannot be obtained or exchanged for real money in
              any way. The G-POINTS balance is reset and does not have monetary value.
            </p>
          </div>
          <div>
            <h1>5. Data from third party sources</h1>
            <p>
              We may obtain additional information from third parties sources, such as advertisers,
              games or services you use, or social media networks (such as Instagram, Facebook) for
              which you have approved our access. When you access our services through social media
              networks, or when you connect our services to social media networks, you are
              authorizing WRewards to collect, store, and use such additional information and
              content in accordance with this Privacy Policy. We use this information to supplement
              the information we collect about you in order to provide more relevant, safer
              experiences for you and improve our services, analytics, and advertising. If we
              combine or associate information from other sources with information that we collect
              through our services, we will treat the combined information in accordance with this
              Privacy Policy.
            </p>
          </div>
          <div>
            <h1>6. Who can use the Site</h1>
            <p>
              By accessing the Website, the User or guest who is a natural person, confirms to be at
              least 18 years old and to have full legal capacity. Access to the Website is
              restricted to any persons under 18 years of age or under the age at which online
              “gambling” in the jurisdiction of the User is prohibited. It is the User’s sole
              responsibility to determine whether it is legal to “gamble” online within his or her
              jurisdiction, as well as checking any other legal requirements in force.
            </p>
            <p>
              To use the Site, you must be: over 18 years of age or above the legal age for
              “gambling” in the country you are playing from; an actual person. You cannot be a
              company or other legal entity; One person using one address, one phone number, and/or
              one IP address.
            </p>
          </div>
          <div>
            <h1>7. How you can use the Site</h1>
            <p>7.1.1 Click on the &quot;Login&quot; button.</p>
            <p>
              7.1.2 You must login with your Twitch.tv details; please click the “login with Twitch
              Account” button.
            </p>
            <p>
              7.1.3 You will be redirected to Twitch.tv where you will need to log in with your
              Twitch.tv Username and Password.
            </p>
            <p>
              7.1.8 After logging in to your Twitch.tv account, click &apos;Authorize&apos; to
              connect to WRewards.com.
            </p>
            <p>
              7.1.9 You will then be redirected to WRewards.com and will be logged in with your
              Twitch.tv information.
            </p>
          </div>
          <div>
            <h1>7.2 Giveaways</h1>
            <p>
              7.2.1 WRewards.com will facilitate and promote giveaways and prizes by WRewards and/or
              sponsored by affiliated Casinos on our website “Shop” and “Giveaway” pages with the
              sole purpose of showing gratitude to and rewarding our loyal users.
            </p>
            <p>7.2.2 The Terms and Conditions for Giveaways can be found here.</p>
            <p>
              7.2.3 Any and all sponsored items/offers in Giveaways are subject to the Terms and
              Conditions of the Casino that sponsors the item/offer.
            </p>
            <p>
              7.2.4 The sponsored items offered in the Giveaways may be pecuniary or non-pecuniary
              in nature.
            </p>
            <p>
              7.2.5 Any entry to the Giveaway is only available once per person, user account,
              family, household, address, e-mail address, computer/device and/or IP address.
            </p>
            <p>
              7.2.6 Any and all Giveaways will be conducted through the use of the third party
              website, gleam.io. Gleam T&Cs apply.
            </p>
            <p>
              7.2.7 Any and all Giveaways offered on Gleam will have their own individual set of
              prerequisite rules on how to enter the giveaway that will be posted on the page of the
              Giveaway offer. Please read these rules carefully in order to qualify to enter into
              the Giveaway.
            </p>
          </div>
          <div>
            <h1>7.3 WRewards Store</h1>
            <p>
              7.3.1 WRewards.com will facilitate and promote prizes sponsored by WRewards and/or
              prizes from affiliated Casinos on our website “Shop” page with the sole purpose of
              showing gratitude to and rewarding our loyal users.
            </p>
            <p>
              7.3.2 Any and all sponsored items/offers in Shop are subject to the Terms and
              Conditions of the Casino that sponsors the item/offer.
            </p>
            <p>
              7.3.3 The sponsored items offered in the Shop may be pecuniary or non-pecuniary in
              nature
            </p>
            <p>
              7.3.4 Any prize claimed in the Shop is only available once per person, user account,
              family, household, address, e-mail address, computer/device and/or IP address.
            </p>
          </div>
          <div>
            <h1>8. General Terms for you</h1>
            <p>
              8.1 You must register/login and use this website on your own behalf only and not on
              behalf of anyone else.
            </p>
            <p>
              8.2 You must keep Your login details (Name, Password or other credentials) secure and
              not share them with anyone. If you share them, even unintentionally, you are
              responsible for any abuse or misuse of your account. We accept no liability for any
              loss and/or information lost due to unauthorized use of Your Account arising from
              improper use of Your login details. It is Your responsibility to ensure that You keep
              Your details confidential and it is your responsibility to secure any linked email
              address, personal computer or other device on which Your user account is accessible.
              You are fully responsible for any misuse of Your login details or devices. If You are
              concerned that Your credentials have been disclosed to a third party You should notify
              Support immediately so that We may provide You with a new password. Unless caused by
              any negligence on Our part, any unauthorized use of Your login details and any
              unauthorized use of Your account are Your sole responsibility and will be deemed as
              Your own use.
            </p>
            <p>
              8.3 If you realize that the information provided at registration or on your account is
              incorrect, you must tell us immediately or immediately amend your information.
            </p>
            <p>
              8.4 It is your responsibility to know if your activity on the Site is legal in the
              country or territory from which you are accessing the Site.
            </p>
            <p>
              8.5 Only one account is allowed for your real personal data. Opening an account is
              allowed only for one person, using one address, one phone number, and one IP address.
              Any other accounts that are opened on the Website will be considered as “Duplicate
              Accounts.” In that case, WRewards.com reserves the right to close all of the Duplicate
              Accounts and to apply the following sanctions: each action performed using a Duplicate
              Account is considered void, and we reserve the right to close all duplicate accounts,
              and/or ban or delete the user’s original account for misuse of this Website.
            </p>
            <p>
              8.6 If while a Duplicate Account was active, promotional Giveaway or Shop winnings
              were obtained from the Duplicate Account, these will be lost and WRewards.com retains
              the right to retract the win and to ask for the return of those assets.
            </p>
            <p>
              8.7 WRewards.com reserves the right to cancel participation in any promotion, as well
              as permanently ban any user from the Website. We also reserve the right to close an
              existing account without any prior written notice or any explanation.
            </p>
            <p>
              8.8 You are not allowed to transfer or receive funds from one account to another
              and/or to transfer, sell or buy accounts.
            </p>
            <p>
              8.9 You cannot use any technical error or vulnerability to your advantage. We will be
              entitled to cancel and reclaim all winnings gained in this manner.
            </p>
            <p>
              8.10 You will not be involved in any fraudulent, collusive, fixing or other unlawful
              activity in relation to your (or third party) use of the Site. You shall not use any
              software assisted methods or techniques or hardware devices in aid of your
              participation of the Games, Giveaways, and/or Shop on the Site.
            </p>
            <p>
              8.11 You agree that we may also share your information with other people or
              businesses, in line with our Privacy Policy, in order to carry out our business and
              deliver the Site to you.
            </p>
            <p>
              8.12 Point Farming Policy
              Users are strictly prohibited from point farming to
              participate in the store or raffles. This includes, but is not limited to, logging all
              chat activity as &quot;WG&quot; or similar repetitive messages. Points must be earned through
              active participation in streams. Failure to comply may result in penalties, including
              loss of points or account termination.
            </p>
          </div>
          <div>
            <h1>9. What we can do</h1>
            <p>9.1 We can refuse to open an account for any reason.</p>
            <p>
              9.2 We can suspend or close your account for any breach or suspected breach of this
              Agreement or other valid reason.
            </p>
            <p>
              9.3 If you try to open any other account, on top of your first account, we will block
              or close the account. We may also block or close your first account.
            </p>
            <p>
              9.4 If we find there is more than one account registered for your household, or IP
              address we will block or close any accounts for that household or IP address.
            </p>
            <p>
              9.5 We may share your personal information with other people or businesses, in line
              with our Privacy Policy and as agreed upon by your usage of our Site.
            </p>
            <p>
              9.6 If you are found to be using the Website in any way for which it is not intended,
              which is to be informational, fun, and recreational, we reserve the right to ban or
              delete Your Account to remove any pecuniary or non-pecuniary winnings gained from such
              activity, and the account may be permanently closed.
            </p>
            <p>
              9.7 We will declare entrance into a Giveaway or your trade in the Shop to be fully
              void (and/or close Your Account) if we believe that any of the following apply: You,
              or people associated with you may have directly or indirectly influenced the outcome
              of an event; You, or people associated with you may have access to insider knowledge
              that can influence the outcome of an event; You and or people associated with you
              directly or indirectly ignore the Terms; The result of an event has been directly or
              indirectly affected by criminal activity; A significant change in odds happened, for
              example due to a public announcement in relation to an event; Entrance to a Giveaway
              or Trade in the Shop was accepted that we would not have accepted, due to a technical
              issue affecting the Site at that point in time or a mistake, misprint and/or anything
              which is outside our control.
            </p>
            <p>
              9.8 If we suspect that you are involved in illegal or fraudulent activities relating
              to your use of the Site (or a third parties use of the Site) or are involved in any
              other behavior detrimental to the Site, we may freeze or close Your Account without
              any prior notice.
            </p>
          </div>
          <div>
            <h1>10. Closing Your Account</h1>
            <p>
              10.1 You can close Your Account at any time, by contacting Support directly via the
              “Contact” form that is found under the “About” tab at the bottom of the WRewards
              website.
            </p>
            <p>
              10.2 When you close your Account: You must contact support and specifically request
              for the closing of Your Account;
            </p>
            <p>
              10.3 If you are closing Your Account because you have a problem with gambling
              addiction please refer to section 11 of these Terms.
            </p>
            <p>
              10.4 If your account has been closed by us due to a violation of these terms, we
              reserve the right to refuse to re-activate your account.
            </p>
            <p>
              10.5 If your account is closed either by you or by us, and you have outstanding
              pecuniary or non-pecuniary winnings that have not been claimed by you, we reserve the
              right to retract those winnings and not award them to the user. If the user account
              has been closed for a violation of these Terms, we reserve the right to retract any
              and all winnings and not award them to the user.
            </p>
          </div>
          <div>
            <h1>11. Links To Our Affiliate And Partner Websites</h1>
            <p>
              We make every effort to provide you with links to the best websites on the internet;
              best in terms of offer, quality and security. As previously mentioned, please make
              sure to read terms of use for each site, as our privacy policy does not extend to our
              affiliate and partner websites.
            </p>
          </div>
          <div>
            <h1>11.1 Your Rights</h1>
            <p>
              You reserve the following rights in respect to your data: Right of access - you can
              ask us to provide your personal data we hold on our secure storage. You may ask us to
              delete, modify or update the data. If for legal reasons we are forced to refuse your
              request, we will provide you with reference and explanation as to why this is the
              case. Right to correct -if any detail of your data is not correct, you may ask us to
              update the data. Right to erase - based upon your request we will completely and
              irrevocably delete your data; after this you will not be able to use our website.
              Please contact Support to request your account removal and data deletion. Our Support
              Representatives will receive the request and completely erase your account and all the
              traces you have left on WRewards.com.
            </p>
          </div>
          <div>
            <h1>12. Responsible gaming</h1>
            <p>
              12.1 Gambling can be addictive. If you need some help to overcome such addiction,
              kindly follow this link(https://www.begambleaware.org/) which will redirect you to a
              responsible gaming page. No shame, no judgment, just help.
            </p>
            <p>
              12.2 Test Yourself - Self-Assessment Test If you are concerned about whether you are
              having a gambling problem or you think you already have a gambling problem, then try
              the Self-Assessment Test offered by Be Gamble Aware here. You may find the result
              interesting. If you are concerned about your test result, consider deleting your
              account via contacting Support, or generally contact Support for further assistance
              and advice. You may always access help on the Be Gamble Aware website, which can be
              found here.
            </p>
          </div>
          <div>
            <h1>13. How to complain</h1>
            <p>
              13.1 If you have any complaints about the Service(s) provided on this website, please
              contact the Customer Services department by first filling out the “Contact Me” form
              that is found under the “Support” tab. We aim to answer all requests within 10
              business days of receipt of your communication. Where the nature of the inquiry is
              such that more time is necessary to complete, such period may be extended by a further
              ten days. You shall be informed within the first ten days from the date of receipt of
              the complaint, should this period need to be extended.
            </p>
            <p>
              13.2 In order for us to deal with your complaint quickly and efficiently, please
              provide us with clear information about your identity as well as all relevant details
              giving rise to the issue. We will use best efforts to promptly resolve a reported
              matter and reach an amicable settlement.
            </p>
            <p>
              13.3 Any claim you might have regarding Offers must be made within 7 days after the
              final results of the Offer (for example if you have a complaint about entrance into a
              Giveaway or complaint about the results of a giveaway; otherwise we will not consider
              the claim. Once a claim is received, we will review any queried or disputed
              transactions and let you know the outcome. Our decision on this is final, in simple
              terms, what we say goes.
            </p>
          </div>
          <div>
            <h1>14. Privacy policy</h1>
            <p>
              You can read our Privacy Statement{" "}
              <Link
                style={{ textDecoration: "underline" }}
                target="_blank"
                href={"/privacy-policy"}
              >
                here
              </Link>
              . You should be aware that acceptance of the Terms includes full acceptance of the
              terms of our Privacy Statement. We therefore ask that you read the Privacy Statement
              carefully.
            </p>
          </div>
          <div>
            <h1>15. Your liability to us</h1>
            <p>
              15.1 You enter the Site and participate at your own risk. The Site is provided ‘as
              is’. The only promises we make in relation to the Site are detailed in these Terms. We
              do not warrant (in simple language, we do not legally promise) that: The software or
              the Site is fit for purpose and free from errors; The Site will be accessible without
              interruptions;
            </p>
            <p>
              15.2 We shall not be liable for anything, this includes any loss, costs, expenses or
              damages, whether direct, indirect, special, consequential, incidental or otherwise
              arising in relation to your use of the Site.
            </p>
            <p>
              15.3 You hereby agree to fully indemnify us (in simple language, compensate us for any
              loss) and directors, employees, partners, and service providers for any cost, expense,
              loss, damages, claims and liabilities howsoever caused that may arise in relation to
              your use of the Site or participation in the Games. If you don’t agree to this, you
              should not use the Site.
            </p>
          </div>
          <div>
            <h1>16. Breaches, penalties and termination</h1>
            <p>
              16.1 If we suspect that you have breached these Terms, we may refuse to open, suspend
              or close Your Account.
            </p>
            <p>
              16.2 We also have the right to ban or terminate Your Account if: We suspect that you
              are engaged in illegal or fraudulent activities; We believe that you have been abusing
              the Site; (see aforementioned definition of “abuse”) You are in violation of any of
              the terms herein.
            </p>
            <p>16.3 OUR DECISION IS FINAL.</p>
          </div>
          <div>
            <h1>17. Intellectual property</h1>
            <p>
              17.1 www.WRewards.com or any other subdomains is our uniform resource locator and no
              unauthorized use may be made of this URL on any other Site or digital platform without
              our prior written consent. Links to the Site and any of the pages therein may not be
              included in any other Site without our prior written consent.
            </p>
            <p>
              17.2 We are the owner or the rightful licensee of the rights to the technology,
              software and systems used within the Site.
            </p>
            <p>
              17.3 You agree not to use any automatic or manual device to monitor our web pages or
              any content therein. Any unauthorized use or reproduction may be prosecuted.
            </p>
          </div>
          <div>
            <h1>18. Severability</h1>
            <p>
              If any provision of these Terms is held to be illegal or unenforceable, such provision
              shall be severed from these Terms and all other provisions shall remain in force
              unaffected by such severance.
            </p>
          </div>
          <div>
            <h1>19. Entire agreement and admissibility</h1>
            <p>
              19.1 The Terms are the entire agreement between us with respect to this Site and,
              except in the case of fraud, overrule all prior communication and proposals, whether
              electronic, oral or written, between us.
            </p>
            <p>
              19.2 A printed version of these Terms and any notice given in electronic form shall be
              admissible in judicial or administrative proceedings.
            </p>
          </div>
          <div>
            <h1>20. Assignment</h1>
            <p>
              We can assign or transfer this agreement. You cannot assign or transfer this
              agreement.
            </p>
          </div>
          <div>
            <h1>21. Appendix</h1>
            <p>21.1 Prohibited Use of Account</p>
            <p>
              21.1.1 No Bots/Artificial Intelligence You must not use bot software or artificial
              intelligence, whether commercially obtained or privately developed, when playing on or
              using the Site. &quot;Bots&quot; are software programs or other devices which
              interfere with the game software and/or our Site. Bots may use Terms or artificial
              intelligence to make playing decisions or alter our Website without our consent. We
              will actively look for such software in accordance with these Terms. Consent to these
              Terms will also establish that the user will not interfere with any of the detection
              mechanisms. This clause applies regardless of whether the bot is actually used in
              conjunction with the Games or otherwise.
            </p>
            <p>
              21.1.2 No Prohibited Software Other types of software are also prohibited, these
              include but are not limited to software which: Gives You any sort of unfair advantage;
              Shares loopholes to users or guests, or assists collusion or cheating in any way;
              Utilizes a database of user profiles which is shared between users; Reduces or
              eliminates the need for a human to make decisions in any way shape or form; Is
              designed to datamine (i.e. gather information on user profiles from the website beyond
              what the user has observed from their user profile) for any purpose whether personal
              or commercial. This also applies to any data which has been obtained by datamining,
              whether the data was obtained by the user themselves or by anyone else. You are
              furthermore prohibited from sharing of any legitimately gathered data with other
              users; Attempts to block any of our abuse detection mechanisms.
            </p>
            <p>
              21.1.3 No Collusion It is prohibited for users to act as a team, with or without prior
              explicit agreement, to the actual or possible detriment of other users of the Site.
              You must: Not work together with another user to gain an advantage; Not share personal
              information with any other user; Not encourage any other user to collude.
            </p>
            <p>
              21.1.4 No Account Sharing Users must not share their account, under any circumstances,
              with any other person as this would tantamount to &quot;Multiple Account Abuse&quot;.
              It is thus prohibited for any user to gain an advantage by sharing an account with any
              individual. Accordingly, a user may not use any account other than their own, and must
              keep their credentials (alias, password, and any other information used to access the
              user account) secret and not reveal them to any other person.
            </p>
            <p>
              21.1.5 No Unfair Advantages Any attempt to gain an unfair advantage over other users,
              whether specifically prohibited by the Terms or not, is strictly prohibited. Any
              activity that is designed to give a user an unfair advantage, but which may be allowed
              under a strict interpretation of the Terms, due to a loophole or due to unintended
              software characteristics is still prohibited.
            </p>
            <p>
              21.1.6. No Problem Gamblers It is prohibited for anybody with a gambling problem to
              sign up for an account under any circumstances. If a user discovers that s/he has a
              gambling problem, s/he is required to inform us and cease play immediately.
            </p>
            <p>
              21.1.7 The User&quot;s Account Can Be Locked/Closed Without Prior Notice We have the
              right to lock and/or permanently close the user account at our discretion and without
              prior notice. This is done with the aim of stopping the use of the account while
              WRewards.com performs investigations and for any other reason We deem it fit.
            </p>
          </div>
          <div style={{ marginTop: 50 }}>
            <p>
              WRewards.com is not responsible for incorrect information on bonuses, offers, or
              promotions listed on the website. WRewards.com recommends that the user reviews all
              the terms and conditions of all bonuses listed on the Casino’s website.
            </p>
          </div>
        </TermsContainer>
      </Container>
    </PageBox>
  );
}
